import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/app-marketing/delivering.webp";

function Banner(props) {
  return (
    <div className="experienced p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              TekRevol Delivering Value as a Leading App Marketing Agency in
              Dubai
            </h2>
            <p>
              At TekRevol, our commitment to top-notch technology solutions led
              us to delve deep into the intricate world of mobile app marketing.
              Now, as the premier authority in Dubai and across the GCC for app
              marketing, we specialize in delivering the exact results our
              clients crave.
            </p>
            <p>
              As premier app marketers in the region, we are focused on
              delivering user-centric experiences and providing maximum ROI to
              our clients. Whether it is search engine marketing, app store
              optimization, or reaching new users through native or social media
              ads. With a tailored and strategic approach, we craft solutions
              designed to elevate your app's standing in the market. We explore
              all the appropriate channels to enable growth for your brand.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let's Take Your Brand Online
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
